export const TrendUpIcon = () => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M11 6.33334L8.2 9.13334L7.13333 7.53334L5 9.66668'
            stroke='#D92D20'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M9.6665 6.33334H10.9998V7.66668'
            stroke='#D92D20'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M6.00016 14.6667H10.0002C13.3335 14.6667 14.6668 13.3333 14.6668 10V6.00001C14.6668 2.66668 13.3335 1.33334 10.0002 1.33334H6.00016C2.66683 1.33334 1.3335 2.66668 1.3335 6.00001V10C1.3335 13.3333 2.66683 14.6667 6.00016 14.6667Z'
            stroke='#D92D20'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
